import { useState, useEffect } from "react";

import { useStore } from "../../../store";

import FormContainer from "../../../components/atoms/forms/formContainer";
import Search from "../../../components/select/Search";
import Loader from "../../../components/atoms/loader";
import Axios from "../../../AxiosConfig";


import { useNavigate } from "react-router-dom";
const NewLeave = () => {
    const today = new Date();
    var min_year = (today.getFullYear() - 1).toString();
    var max_year = (today.getFullYear() + 1).toString();
    var now_year = (today.getFullYear()).toString();
    var now_month = today.getMonth() + 1;
    if (now_month < 10){
        now_month = "0" + now_month.toString()
    }
    else{
        now_month =  now_month.toString()
    }
    var now_date = today.getDate()
    if (now_date < 10){
        now_date = "0" + now_date.toString()
    }
    else{
        now_date = now_date.toString()
    }
    const { layoutStore } = useStore();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [employee, setEmployee] = useState(undefined);
    const [leaveBalance, setLeaveBalance] = useState(0);
    const [leaveType, setLeaveType] = useState("single-day");
    const [startDate, setStartDate] = useState(now_year + '-' + now_month + '-' + now_date);
    const [endDate, setEndDate] = useState(now_year + '-' + now_month + '-' + now_date);
    const [readyToCalculate, setReadyToCalculate] = useState(false);
    const [isCalculated, setIsCalculated] = useState(false);
    const [missedDays, setMissedDays] = useState(0);
    const [leaveReason, setLeaveReason] = useState("");

    useEffect(() => {
        setReadyToCalculate(false);
        if (leaveType === "single-day") {
            if (startDate !== undefined) {
                setReadyToCalculate(true);
            }
        } else if (leaveType === "multiple-days") {
            if (startDate !== undefined && endDate !== undefined) {
                setReadyToCalculate(true);
            }
        }
    }, [leaveType, startDate, endDate]);

    useEffect(() => {

        if (employee) {
            setLoading(true);
            Axios.post("/working-days/get-leave-balance", {
                uuid: employee.uuid
            }).then((res) => {
                if (res.data.success) {
                    setLeaveBalance(res.data.leaveBalance);
                    setLoading(false);
                }
                else {
                    layoutStore.showToaster(res.data.error, "error")
                    setLoading(false);
                }
            })
        }
    }, [employee]);

    const calculateWorkingDays = () => {
        setIsCalculated(false);
        setMissedDays(0);
        setLoading(true);
        Axios.post("/working-days/get-working-days", {
            startDate,
            endDate,
            leaveType,
            uuid: employee.uuid
        }).then((res) => {
            if (res.data.error) {
                layoutStore.showToaster(res.data.error, "error")
                setLoading(false);
            }
            else {
                setMissedDays(res.data.workingDays);
                setIsCalculated(true);
                setLoading(false);
            }
        })
    }

    const applyForLeave = () => {
        setLoading(true);
        Axios.post("/working-days/apply-for-leave", {
            startDate,
            endDate,
            leaveType,
            leaveReason,
            uuid: employee.uuid
        }).then((res) => {
            if (res.data.error) {
                layoutStore.showToaster(res.data.error, "error")
                setLoading(false);
            }
            else {
                layoutStore.showToaster("New Leave Set For Employee", "success")
                setLoading(false);
                navigate("/leaves");
            }


        })
    }
    const goBackButton = () => {
        navigate('/leaves')
    }

    return (
        <div>
            {loading && <Loader />}
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                Create A Leave
            </h2>
            <div className="mt-4 pt-4 border-t">
                <FormContainer title="Employee" description="Select An Employee To Create A Leave For">
                    <div className="border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                        <Search
                            apiURL="/employee/search"
                            setParent={setEmployee}
                        />
                    </div>
                </FormContainer>
                {employee &&
                    <>
                        <FormContainer title="Leave Balance" description="Number Of Leave Days Left">
                            <div>
                                {leaveBalance} Days
                            </div>
                        </FormContainer>
                        <FormContainer title="Leave Type" description="Choose Between Single Day Or Multiple Days">
                            <div>
                                <fieldset className="mt-4">
                                    <legend className="sr-only">Notification method</legend>
                                    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                                        <div className="flex items-center">
                                            <input
                                                id={"single-day"}
                                                name="leave-type"
                                                type="radio"
                                                defaultChecked={true}
                                                onChange={() => {setLeaveType("single-day"); setIsCalculated(false)}}
                                                className="h-4 w-4 border-gray-300 hover:border-blue-500 text-blue-600 focus:ring-blue-500"
                                            />
                                            <label htmlFor={"single-day"} className="ml-3 block text-sm font-medium text-gray-700">
                                                Single Day
                                            </label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id={"multiple-days"}
                                                name="leave-type"
                                                type="radio"
                                                onChange={() => {setLeaveType("multiple-days"); setIsCalculated(false)}}
                                                className="h-4 w-4 border-gray-300 hover:border-blue-500 text-blue-600 focus:ring-blue-500"
                                            />
                                            <label htmlFor={"multiple-days"} className="ml-3 block text-sm font-medium text-gray-700">
                                                Multiple Days
                                            </label>
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                        </FormContainer>
                        {
                            leaveType === "single-day" &&
                            <FormContainer title="Leave Date" description="Choose The Date For Leave">
                                <div>
                                    <label htmlFor="leaveDate" className="block text-sm font-medium text-gray-700">
                                        Leave Date
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            type="date"
                                            name="leaveDate"
                                            id="leaveDate"
                                            min={min_year + '-' + now_month + '-' + now_date}
                                            max={max_year + '-' + now_month + '-' + now_date}
                                            value={startDate || ''}
                                            onChange={(e) => {
                                                setIsCalculated(false)
                                                if (e.target.value > max_year + '-' + now_month + '-' + now_date){
                                                    setStartDate(max_year + '-' + now_month + '-' + now_date)
                                                } else{
                                                    setStartDate(e.target.value)
                                                }
                                                if (new Date(e.target.value) > new Date(endDate) || !endDate) {
                                                    setEndDate(e.target.value)
                                                }
                                            }}
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"

                                        />
                                    </div>
                                </div>
                            </FormContainer>
                        }
                        {
                            leaveType === "multiple-days" &&
                            <FormContainer title="Leave Date" description="Choose The Start and End Date For Leave">
                                <div>
                                    <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                                        Start Date
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            type="date"
                                            name="startDate"
                                            id="startDate"
                                            min={min_year + '-' + now_month + '-' + now_date}
                                            max={max_year + '-' + now_month + '-' + now_date}
                                            value={startDate || ''}
                                            onChange={(e) => {
                                                setIsCalculated(false)
                                                if (new Date(e.target.value) > new Date(endDate) || !endDate) {
                                                    setEndDate(e.target.value)
                                                }
                                                if (e.target.value > max_year + '-' + now_month + '-' + now_date){
                                                    setStartDate(max_year + '-' + now_month + '-' + now_date)
                                                    setEndDate(max_year + '-' + now_month + '-' + now_date)
                                                } else{
                                                    setStartDate(e.target.value)
                                                }
                                            }}
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"

                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                                        End Date
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            type="date"
                                            name="endDate"
                                            id="endDate"
                                            disabled={startDate === undefined}
                                            value={endDate || ''}
                                            onChange={(e) => {
                                                setIsCalculated(false)
                                                // if (new Date(e.target.value) < new Date(startDate) || !startDate) {
                                                //     setStartDate(e.target.value)
                                                // }
                                                if (e.target.value > max_year + '-' + now_month + '-' + now_date){
                                                    setEndDate(max_year + '-' + now_month + '-' + now_date)
                                                } else{
                                                    setEndDate(e.target.value)
                                                }
                                            }}
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            min={startDate}
                                            max={max_year + '-' + now_month + '-' + now_date}
                                        />
                                    </div>
                                </div>
                            </FormContainer>
                        }
                        <hr />
                        <div className="mt-4">
                            <FormContainer title="Step 1" description="Calculate Leave Days and Availabilty. Against Companies Database">
                                <div>
                                    {isCalculated && <table className="min-w-full divide-y divide-gray-300">
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            <tr>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Leave Days</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{missedDays}</td>
                                            </tr>
                                            <tr>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Remaining Days After Leave</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{leaveBalance - missedDays}</td>
                                            </tr>
                                        </tbody>
                                    </table>}
                                    <button
                                        type="button"
                                        disabled={!readyToCalculate}
                                        onClick={calculateWorkingDays}
                                        className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Calculate
                                    </button>
                                </div>
                            </FormContainer>
                            <FormContainer title="Step 2" description="Send Leave Request To HR">
                                <div>
                                    {(isCalculated && missedDays !== 0 ) &&
                                        <div>
                                            <label htmlFor="leaveReason" className="block text-sm font-medium text-gray-700">
                                                Leave Reason
                                                <span className="asterisk">*</span>
                                            </label>
                                            <div className="my-2">
                                                <textarea
                                                    id="leaveReason"
                                                    name="leaveReason"
                                                    value={leaveReason || ''}
                                                    rows={3}
                                                    onChange={(e) => {
                                                        setLeaveReason(e.target.value);
                                                    }}
                                                    className="shadow-sm focus:ring-blue-500 hover:border-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md resize-none"
                                                    placeholder="Leave Reason"
                                                    defaultValue={""}
                                                    maxLength={"60"}
                                                />
                                            </div>
                                        </div>
                                    }
                                    <button
                                        type="button"
                                        disabled={!isCalculated || !missedDays || leaveReason.length === 0}
                                        onClick={applyForLeave}
                                        className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Send Request
                                    </button>
                                </div>
                            </FormContainer>
                        </div>
                    </>
                }

            </div>
        </div>
    );
}
export default NewLeave;